// getter/setter for the search term
import { atom } from "jotai";
import {
  ExpectedSearchParams,
  searchParamsAtom,
  setSearchParamsHelper,
} from "./locationAtom";

export const searchTermAtom = atom(
  (get) => {
    return get(searchParamsAtom).term || "";
  },
  (get, set, value: string) => {
    const key: keyof ExpectedSearchParams = "term";
    setSearchParamsHelper(get, set, { key, value, clear: true });
  },
);

searchTermAtom.debugLabel = "Search Term Atom";
